import React from 'react';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import {
  ContainerFlashSales,
  ContainerLastminuteDeals,
} from '@/app/components/search/components/EvolutionCard/Gallery/FlashSalesBadge/styled.ts';
import { css } from 'styled-components';
import { TextContainer } from '@/app/common/components/Promotions/LastMinuteDealsBadge/styled.ts';
import TsxTooltip from '@/app/components/search/components/Tooltip/TsxTooltip';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { useIconColorHex } from '@/app/common/icons/Icon';
import { starfishCssUrl } from '@/app/common/icons/starfish';
import { flashSalesIconSize } from '@/app/common/icons/promotionIcons';

const lmdTextPreset = css`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
`;

const FLASH_SALES_BADGE_ICON = flashSalesIconSize(16);

const FlashSalesBadge = () => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { isMobile } = useCommonClient();
  const primaryHex = useIconColorHex('iconPrimary');
  const imageBasePath = localization?.imageBasePath;
  const lastMinuteDeals = localization?.configValuesApp?.lastMinuteDeals;
  const tooltipLabel = t('vacation.oss.cards.limited_availability_tooltip');

  const tooltipProps = {
    tooltip: tooltipLabel,
    isMobile,
    size: 233,
  };

  if (lastMinuteDeals) {
    return (
      <ContainerLastminuteDeals>
        <TextContainer
          dangerouslySetInnerHTML={{ __html: t('vacation.oss.last_minute_deals.label_HTML') }}
          $icon={`${imageBasePath}icons/last_minute_deals_underline_white.svg`}
          $color="#FFFFFF"
          $preset={lmdTextPreset}
        />
        <TsxTooltip
          {...tooltipProps}
          iconSrc={{ category: 'Semantics', name: 'icon-circle-info', color: 'iconOnDark' }}
        />
      </ContainerLastminuteDeals>
    );
  }

  return (
    <ContainerFlashSales
      $icon={starfishCssUrl('Brands and products', 'icon-flash-sales', primaryHex, FLASH_SALES_BADGE_ICON)}
      $iconSize={FLASH_SALES_BADGE_ICON}
    >
      <span dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.flash_sales_label') }} />
      <TsxTooltip
        {...tooltipProps}
        iconSrc={{ category: 'Semantics', name: 'icon-circle-info', color: 'iconPrimary' }}
      />
    </ContainerFlashSales>
  );
};

export default FlashSalesBadge;
